import { useState } from 'react';
import {
  DevHubAlert,
  DevHubBox,
  DevHubGrid,
  DevHubTooltip,
  DevHubTypography,
} from '@devxdiscover/devhub-ui';
import ExportResourcesReport from './ExportResourceReport';
import { useAppId } from '../../contexts/SystemContext';
import { InfoCard } from '@backstage/core-components';

export type Severity = 'success' | 'info' | 'warning' | 'error';

/**
 * Component to display the Resources Report section in the DevHub Insights page.
 * It includes an alert for notifications and a button to export the resource report.
 * @returns Component created to show new Green Energy Score
 */
const ResourcesReportContent = () => {
  const appId = useAppId();
  const [alert, setAlert] = useState({
    open: false,
    message: '',
    severity: 'info',
  });

  const handleAlert = ({ open, message, severity }: any) => {
    setAlert({ open, message, severity });
  };

  return (
    <>
      <InfoCard>
        <DevHubGrid container justifyContent="space-between">
          <DevHubGrid item>
            <DevHubTypography variant="h6" gutterBottom>
              Generate Resource Report{' '}
              <DevHubTooltip
                placement="top"
                title="Export application resource data for CGA audits and compliance."
                type="icon"
                icon="help"
              />
            </DevHubTypography>
          </DevHubGrid>
          <DevHubGrid item>
            <ExportResourcesReport appId={appId} handleAlert={handleAlert} />
          </DevHubGrid>
        </DevHubGrid>
      </InfoCard>
      <DevHubBox>
        {alert.open && (
          <DevHubAlert
            variant="outlined"
            severity={alert.severity as Severity}
            onClose={() => setAlert({ ...alert, open: false })}
          >
            {alert.message}
          </DevHubAlert>
        )}
      </DevHubBox>
    </>
  );
};

export default ResourcesReportContent;
